import '../scss/styles.scss';
import scrollToSection from "./ScrollToSection"

export default function Home() {
    return (
        <section id="home" className="home">
            <div className="home-wrapper">
                <div className="home-img" loading="lazy"></div>
                <div className="home-text">
                    <h3>Faraway Sound Productions</h3>
                    <h1>Audio, Visual, & Information Technology</h1>
                    <p>
                    We provide a high-level of professional on-site service, support, and equipment for a wide variety of events. <span>Faraway Sound Production's</span> services include Audio & Visual Engineering, Information Technology, and <span>Audio Equipment Rentals</span>. Please inquire about our expanding list of equipment.
                    </p>
                    <div className="book-now-button">
						<a className="book-now-btn"
							href="#book-now"
							onClick={scrollToSection}>Book Now</a>
				    </div>
                </div>
            </div>
        </section>
    )
}